

export class PoiDetailsByCompanyAndBranchOutput implements IPoiDetailsByCompanyAndBranchOutput {
    /** The auto-generated id of the poi details master */
    poi_details_id!: number;
    /** The place name with 255 character limit */
    place_name!: string;

    constructor(data?: IPoiDetailsByCompanyAndBranchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_details_id = _data["poi_details_id"];
            this.place_name = _data["place_name"];
        }
    }

    static fromJS(data: any): PoiDetailsByCompanyAndBranchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PoiDetailsByCompanyAndBranchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_details_id"] = this.poi_details_id;
        data["place_name"] = this.place_name;
        return data; 
    }
}

export interface IPoiDetailsByCompanyAndBranchOutput {
    /** The auto-generated id of the poi details master */
    poi_details_id: number;
    /** The place name with 255 character limit */
    place_name: string;
}

